import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useCancelSubscription = () => {
    const trpc = useTRPC();

    const opts = trpc.subscription.cancel.mutationOptions({
        onSuccess: (_, _vars, _on, context) => {
            context.client.invalidateQueries({ queryKey: trpc.subscription.get.queryKey() });
        },
    });

    return useMutation(opts);
};
